import {
  List,
  Datagrid,
  TextField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  Show,
  SimpleShowLayout,
  required,
} from 'react-admin';

export const AddressLabelList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="address" />
      <TextField source="label" />
    </Datagrid>
  </List>
);

export const AddressLabelEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="address" validate={required()} fullWidth />
      <TextInput source="label" validate={required()} fullWidth />
    </SimpleForm>
  </Edit>
);

export const AddressLabelCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="address" validate={required()} fullWidth />
      <TextInput source="label" validate={required()} fullWidth />
    </SimpleForm>
  </Create>
);

export const AddressLabelShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="address" />
      <TextField source="label" />
    </SimpleShowLayout>
  </Show>
);
